import type { FaireProductEntity } from "../../entity_types/product";

export const p_xsyw828equ: FaireProductEntity = {
  token: "p_xsyw828equ",
  type: "product",
  name: "Maple Walnut Fudge",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl: "https://cdn.faire.com/fastly/28c33af0b3045c2ff2835d4cfcc66efa4f8b9829407d4b2b487aefdd4f3c6062.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99bffb6b340c6aad4292a4b6d43677307b2094295069f8e5228364e30543a639.jpeg"
  ],
  priceDollars: 7.58,
  description: "Our classic Vermont Maple Fudge is mixed with California walnuts so you can crunch your way to maple heaven. We use real Vermont maple syrup, along with maple extract, to make this very maple-y tasting fudge. It’s perfect for an evening dessert with friends. FREE SHIPPING on all orders over $55. \n\nMaple Walnut Fudge in a 1/2 lb resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:52.316Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
